import turbina from "../assets/turbina.png";

export const produtos = [
  {
    id: 1,
    nome: "Turbina para Volvo FH",
    imagem: turbina,
  },
];
